import {Component, OnInit} from '@angular/core';

import {ProductsCategory} from './products-category';
import {ProductsArticle} from './products-article';

import {ImportItemsService} from './import-items.service';
import {StockAvailibilityService} from './stock-availibility.service';

import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {AppComponent} from './app.component';

@Component({
    selector: 'import-items',
    templateUrl: './templates/import-items.component.html',
    styleUrls: ['./styles/import-items.component.css'],
    providers: [StockAvailibilityService, SortTable]
})
export class ImportItemsComponent implements OnInit {
    warehouse: string;
    warehouses_list: ProductsCategory[];

    info_article: string = '';

    invalid_list: Array<any>;
    art_list: Array<any>;
    article_selected_list: Array<string> = [];
    article_list: Array<string> = [];
    empty_list: boolean = true;

    success: Array<any>;
    failed: Array<any>;

    save_suppliers: boolean = true;
    save_categories: boolean = true;
    sortedData: any = [];

    constructor(
        private app_component: AppComponent,
        private stock_availibility_service: StockAvailibilityService,
        private import_items_service: ImportItemsService,
        private sort_table: SortTable
    ) {
        this.app_component.valTest = '/import-items';
        this.app_component.GetParent();
    }

    ngOnInit() {
        //        this.isChecked();
        this.getWarehousesList();
    }

    importer(): void {
        //        console.log(this.article_selected_list.length);
        if (this.article_selected_list.length != 0) {
            console.log(this.article_selected_list);
            let checked_list = this.article_selected_list.join('_');
            this.import_items_service.importItem(checked_list, this.warehouse, this.save_suppliers, this.save_categories)
                .then(result => {
                    this.success = result['success'];
                    this.failed = result['failed'];
                });
        }
    }

    getWarehousesList(): void {
        this.import_items_service.getWarehouses()
            .then(result => {
                this.warehouses_list = result['list'];
            });
    }

    getItemsByWarehouse(): void {
        this.import_items_service.getItemsByWarehouse(this.warehouse)
            .then(result => {
                this.art_list = result['list'];
                this.article_list = result['list'];
                this.sortedData = result['list'];
                this.sort_table.SetDataArray(result['list'], [{value: "internal_code", type: ""}, {value: "name", type: ""}]);
                if (result['list'].length !== 0) {
                    this.empty_list = false;
                }
            });
    }

    Sort(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.sortedData = this.sort_table.GetSortData();
        // recupérer  data
    }

    changed(event: any) {
        this.article_selected_list = [];
        this.warehouse = event;
        this.getItemsByWarehouse();
    }

    isChecked(): boolean {
        return this.article_selected_list.length === this.article_list.length;
    }

    isIndeterminate(): boolean {
        return (this.article_selected_list.length !== 0 &&
            this.article_selected_list.length !== this.article_list.length);

    }

    toggleAll(): void {
        if (this.article_selected_list.length === this.article_list.length) {
            this.article_selected_list = [];
        } else if (this.article_selected_list.length === 0 || this.article_selected_list.length > 0) {

            for (let i = 0; i < this.article_list.length; i++) {
                this.article_selected_list[i] = this.article_list[i]['id_article'];

            }
        }
        // this.quantity = this.article_selected_list.length;
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        return selected.indexOf(id_article) > -1;
    }

    Toggle(id_article: string, selected: Array<string>): void {
        var index = selected.indexOf(id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(id_article);
        }
        //this.quantity = selected.length;
    };
}



// WEBPACK FOOTER //
// ./src/app/import-items.component.ts